"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = exports.fetchJSTranslations = exports.updateTranslationsCache = void 0;
const caching_1 = require("./caching");
const LS_KEY = "JS_TRANSLATIONS";
const TRANSLATIONS_REFERENCE_KEY = "translations";
const CACHE_EXPIRATION_HOURS = 24;
exports.updateTranslationsCache = () => caching_1.updateLSCache(LS_KEY, { hours: CACHE_EXPIRATION_HOURS }, fetchJSTranslations).then((v) => console.log("Key was new", !v));
function fetchJSTranslations() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        console.trace();
        let applicationData;
        try {
            applicationData = yield $.ajax({
                url: "/application",
                type: "GET",
            });
        }
        catch (e) {
            throw new Error("Failed fetching application-data");
        }
        console.debug("Fetching translations reference");
        const translationsReference = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData._references) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.find(it => it.name === TRANSLATIONS_REFERENCE_KEY);
        if (!(translationsReference === null || translationsReference === void 0 ? void 0 : translationsReference.href)) {
            throw new Error("Could not find translations reference in /application");
        }
        let translationData;
        try {
            translationData = yield $.ajax({
                url: translationsReference.href,
                type: "GET",
                beforeSend: function () {
                    console.debug("Fetching translations...");
                }
            });
        }
        catch (e) {
            throw new Error("Failed fetching translations");
        }
        const translationLangMap = translationData === null || translationData === void 0 ? void 0 : translationData._entity["translations"];
        console.debug("Translation-Reference Response:", translationData);
        if (!translationLangMap) {
            throw new Error("Fetched Translation-Data was null");
        }
        return translationLangMap;
    });
}
exports.fetchJSTranslations = fetchJSTranslations;
/**
 * Translates a given tag using the currently cached Translations in LocalStorage
 * @param tag
 * @returns The translated string
 */
function translate(tag) {
    const language = window.language;
    if (!language || typeof language !== "string")
        return;
    return JSON.parse(caching_1.getPrefixedFromLS(LS_KEY))[language][tag].value;
}
exports.translate = translate;
